'use client'

import { TransactionSide } from '@marketplace-web/seller-protection/seller-protection-data'

import { useUserProtectionVisibility } from '../../hooks/useUserProtectionVisibility'
import ConversationDetailsSellerProtection from './ConversationDetailsSellerProtection'
import ConversationDetailsBuyerProtection from './ConversationDetailsBuyerProtection'

type Props = {
  isSellerBusiness: boolean
  transactionStatus: number | null | undefined
  shipmentStatus: number | null | undefined
  transactionId: number | undefined
  userSide: TransactionSide | undefined | null
}

const ConversationDetailsMemberProtectionPolicies = ({
  isSellerBusiness,
  transactionStatus,
  shipmentStatus,
  transactionId,
  userSide,
}: Props) => {
  const isSellerProtectionVisible = useUserProtectionVisibility({
    abTestName: 'seller_conversation_details_seller_side_policies',
    transactionStatus,
    isSellerBusiness,
    isCorrectUserSide: userSide === TransactionSide.Seller,
  })
  const isBuyerProtectionVisible = useUserProtectionVisibility({
    abTestName: 'buyer_conversation_details_buyer_side_policies',
    transactionStatus,
    isSellerBusiness,
    isCorrectUserSide: userSide === TransactionSide.Buyer,
  })

  if (isSellerProtectionVisible) {
    return (
      <ConversationDetailsSellerProtection
        transactionId={transactionId}
        shipmentStatus={shipmentStatus}
        transactionStatus={transactionStatus}
      />
    )
  }

  if (isBuyerProtectionVisible) {
    return (
      <ConversationDetailsBuyerProtection
        transactionId={transactionId}
        shipmentStatus={shipmentStatus}
        transactionStatus={transactionStatus}
      />
    )
  }

  return null
}

export default ConversationDetailsMemberProtectionPolicies
